/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import clsx from 'clsx';
// Lib
import { BrandAndThemeProvider } from 'lib/context/BrandAndThemeContext';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getTestProps } from 'lib/testing/utils';
import useIsEditing from 'lib/hooks/useIsEditing';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import useDictionary from 'lib/hooks/useDictionary';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const KeyInformationWrapper = (props)=>{
    const { DynamicPlaceholderId, RenderingIdentifier } = props?.params || {};
    const styles = parseStyleParams(props.params, []);
    const theme = props?.params?.selectTheme;
    const alignment = props?.params?.alignment || 'Left'; // Default: Left
    const phKey = `keyinformation-${DynamicPlaceholderId}`;
    const isEditing = useIsEditing();
    const { getDictionaryValue } = useDictionary();
    const { base, contentWrapper, gridContainer } = TAILWIND_VARIANTS({
        alignment: alignment
    });
    /*
   * Rendering
   */ if (isEditing) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(EditingHelpText, {
                    priority: "warning",
                    children: getDictionaryValue('KeyInformationAddMoreItemsHelpText') || 'Add your first KeyInformation item below, then add more items above or below as needed. You can update the icons using the right panel.'
                }),
                /*#__PURE__*/ _jsx("section", {
                    className: clsx(base(), styles),
                    "data-component": "authorable/shared/content/keyinformationwrapper",
                    ...editingHydrationProps(isEditing),
                    id: RenderingIdentifier,
                    children: /*#__PURE__*/ _jsx(BrandAndThemeProvider, {
                        theme: theme,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: contentWrapper(),
                            children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                                name: phKey,
                                rendering: props?.rendering,
                                render: (components)=>{
                                    return /*#__PURE__*/ _jsx("ul", {
                                        className: gridContainer(),
                                        children: components.map((comp, index)=>/*#__PURE__*/ _jsx("li", {
                                                children: comp
                                            }, index))
                                    });
                                }
                            })
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("section", {
        className: clsx(base(), styles),
        "data-component": "authorable/shared/content/keyinformationwrapper",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`component-key-information-wrapper-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(BrandAndThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/ _jsx("div", {
                className: contentWrapper(),
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKey,
                    rendering: props?.rendering,
                    render: (components)=>{
                        return /*#__PURE__*/ _jsx("ul", {
                            className: gridContainer(),
                            children: components.map((comp, index)=>/*#__PURE__*/ _jsx("li", {
                                    children: comp
                                }, index))
                        });
                    },
                    ...getTestProps(`ph-items`)
                })
            })
        })
    });
};
export const Default = withStandardComponentWrapper(KeyInformationWrapper, false);
const TAILWIND_VARIANTS = tv({
    defaultVariants: {
        alignment: 'Left'
    },
    slots: {
        base: [
            'relative',
            'w-full'
        ],
        contentWrapper: [
            'relative',
            'flex',
            'flex-col'
        ],
        gridContainer: [
            'grid',
            'grid-cols-1',
            'md:grid-cols-2',
            'gap-y-spacing-spacing-24',
            'gap-x-spacing-spacing-8',
            'md:gap-x-spacing-spacing-24',
            'lg:gap-y-spacing-spacing-32'
        ]
    },
    variants: {
        alignment: {
            Left: {
                contentWrapper: [
                    'justify-start',
                    'text-left'
                ]
            },
            Center: {
                contentWrapper: [
                    'justify-center',
                    'text-center',
                    'm-auto'
                ]
            },
            Right: {
                contentWrapper: [
                    'justify-end',
                    'text-right',
                    'float-right'
                ]
            }
        }
    }
});
